export default __webpack_public_path__ + "static/media/XS4 Original + XS4 One +.0ae48e28.jpg";